import { faBars, faBook, faHouse, faLayerGroup, faMap, faPhotoFilm, faScroll, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "@inertiajs/react";
import { useScreenSize } from "../../../hooks/useScreenSize";

interface AdminNavigationBarProps {
  component: string;
}

const menuItems = [
  { component: 'Admin/Homepage/Index', href: '/admin/homepage', icon: faHouse, label: 'Homepage' },
  { component: 'Admin/Reference/Index', href: '/admin/reference', icon: faBook, label: 'Reference' },
  { component: 'Admin/Attachments/Index', href: '/admin/attachments', icon: faPhotoFilm, label: 'Attachments' },
  { component: 'Admin/AttachmentGroups/Index', href: '/admin/attachments/groups', icon: faLayerGroup, label: 'Attachment Groups' },
  { component: 'Admin/Announcements/Index', href: '/admin/announcements', icon: faScroll, label: 'Announcements' },
];

export default function AdminNavigationBar({ component }: AdminNavigationBarProps) {
  const { screenLargerThan } = useScreenSize();
  const isLarge = screenLargerThan('lg');
  const isSmall = screenLargerThan('sm');

  return (
    <div className="navbar bg-base-100 shadow-sm">
      <div className="navbar-start">

        <img src="/logo.png" className={isLarge ? "h-15" : "h-12"} alt="Logo" />
      </div>
      {isLarge && (
        <div className="navbar-center" style={{
          border: '1px solid var(--color-neutral)',
        }}>
          <ul className="menu menu-horizontal bg-base-300 px-2">
            {menuItems.map((item) => (
              <li
                key={item.component}
                className={component === item.component ? "menu-active" : ""}
              >
                <Link href={item.href}>
                  <FontAwesomeIcon icon={item.icon} />
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="navbar-end flex gap-2">
        <Link href="/">
          <button className="btn btn-sm btn-primary">
            <FontAwesomeIcon icon={faUsers} />
            {isSmall && <span>Visitor View</span>}
          </button>
        </Link>
        {!isLarge && (
          <div className="dropdown dropdown-end">
            <div tabIndex={0} role="button" className="btn btn-sm btn-ghost" style={{
              border: '1px solid var(--color-neutral)',
            }}>
              Menu
              <FontAwesomeIcon icon={faBars} className="h-5 w-5" />
            </div>
            <ul
              tabIndex={0}
              className="menu menu-sm dropdown-content bg-base-300 z-[1000] mt-3 w-52 p-2 shadow"
              style={{
                border: '1px solid var(--color-neutral)',
              }}
            >
              {menuItems.map((item) => (
                <li key={item.component} className={component === item.component ? "menu-active" : ""}>
                  <Link href={item.href}>
                    <FontAwesomeIcon icon={item.icon} />
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}
